import React from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { inject, observer } from "mobx-react";
import { AboutPlexModalProvider } from "../modals/AboutPlexModal";
import TutorialButton from "../TutorialButton";
import { useLocation, useNavigate } from "react-router-dom";
import NotificationCenter from "../modals/NotificationCenter";
import {useNotificationCenter} from "react-toastify/addons/use-notification-center";

/**
 * NavBarIconLabel
 * Stacks a glyphicon above a small ALL-CAPS text label.
 */
const NavBarIconLabel = ({ icon, label }) => (
  <span className="navbar-icon-label">
    <span className={'glyphicon ' + icon} aria-hidden="true" />
    <span className="navbar-icon-label__text">{label}</span>
  </span>
);

const InfoMenu = ({className, userStore, tutorialStore, onShowWelcome = null, isLandingPage = false}) => {
  const location = useLocation();
  const navigate = useNavigate();

  // Determine tutorial context based on current route
  const getTutorialContext = () => {
    const path = location.pathname;
    const hash = location.hash;

    // Check if on search results page
    if (path === '/search') {
      return 'results';
    }

    // Check if on landing page in chat mode
    if (path === '/' && hash.indexOf('llm') !== -1) {
      return 'llm';
    }

    // Default to landing page
    return 'landing';
  };

  const tutorialContext = getTutorialContext();
  const showTutorial = userStore && userStore.isAdmin;
  const {notifications, clear} = useNotificationCenter();

  return (
    <span title="About Plex" className="info-menu">
      <DropdownButton
        id="dropdown-info-menu"
        key="info"
        className={className}
        title={<NavBarIconLabel icon="glyphicon-info-sign" label="About" />}
      >
        <AboutPlexModalProvider>
          {({ showModal }) => (
            <Dropdown.Item onClick={() => showModal()}>
              About Plex Search
            </Dropdown.Item>
          )}
        </AboutPlexModalProvider>
        <Dropdown.Divider />
        <Dropdown.Item onClick={() => navigate("/?welcome=true#llm")}>
          Welcome
        </Dropdown.Item>
        <Dropdown.Item onClick={() => navigate("/docs")}>
          User Manual
        </Dropdown.Item>
        <Dropdown.Divider />
        {showTutorial && <TutorialButton context={tutorialContext} />}
        <Dropdown.Divider />
        <Dropdown.Item
          title="Contact support@plexresearch.com"
          href="mailto:support@plexresearch.com"
        >
          Contact support@plexresearch.com
        </Dropdown.Item>
        <NotificationCenter
          notifications={notifications}
          clearNotifications={clear}
        >
          {({ showModal }) => (
            <>
              <Dropdown.Divider />
              <Dropdown.Item
                key={"messages"}
                title={
                  notifications?.length
                    ? "Show system message history and details"
                    : "No system messages"
                }
                disabled={!notifications?.length}
                onClick={() => {
                  if (notifications?.length) {
                    showModal();
                  }
                }}
              >
                {notifications.length
                  ? `Show messages (${notifications?.length})`
                  : "No system messages"}
              </Dropdown.Item>
            </>
          )}
        </NotificationCenter>
      </DropdownButton>
    </span>
  );
}

export default inject("userStore", "tutorialStore")(observer(InfoMenu));
